import React, { useState, useRef, useEffect, RefObject } from 'react';
import useProfileData from '../services/ProfileDataService';
import { PageLayout } from './authentication/PageLayout';
import axios from '../axiosConfig';
const apiUrl = process.env.REACT_APP_API_URL

export const NavMenu = () => {
  const [collapsed, setCollapsed] = useState(true);
  const { userName, profileImage } = useProfileData();
  const [show, setShow] = useState(false);
  const [version, setVersion] = useState<string>("2.0")
  const anchor = useRef<HTMLButtonElement>(null);
  const dropdownRef = useRef<HTMLDivElement>(null);
  const defaultProfileImage = "/defaultProfilePicture.png";

  const togglePopup = () => setShow(prev => !prev);
  const toggleNavbar = () => setCollapsed(!collapsed);
  
  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current && 
        anchor.current && 
        !dropdownRef.current.contains(event.target as Node) && 
        !anchor.current.contains(event.target as Node)
      ) {
        setShow(false);
      }
    };
    
    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
  const fetchVersion = async () => {
    try {
      const response = await axios.get(apiUrl+'/Auth/check-version', { responseType: 'text' });
      const raw = typeof response.data === 'string' ? response.data : String(response.data);
      const normalized = raw.replace(/^"|"$/g, '').trim();
      setVersion(normalized);
    } catch (error) {
      console.error('Error fetching version:', error);
      setVersion('unknown');
    }
  };

  fetchVersion();
}, []);
  return (
    <header className="bg-white border-b border-gray-200">
      {/* Main navbar */}
      <div className="flex items-center justify-between px-4 py-2">
        <div className="flex items-center space-x-2">
          <a href='/'><img className="h-8" src="/logo.svg" alt="Daikin Logo" /></a>
         <span className="text-lg text-[#838689]">
          DPSA Reprocessing Tool
        <span className="ml-2 text-xs font-medium text-white bg-blue-500 px-2 py-0.5 rounded">
          Version: {version}
        </span>
        </span>
        </div>
        
        {/* Profile section */}
        <div className="flex items-center">
          <div className="relative">
            <button 
              className="flex items-center space-x-2 hover:bg-gray-100 rounded-md px-2 py-1 focus:outline-none"
              onClick={togglePopup}
              ref={anchor}
              aria-expanded={show}
              aria-haspopup="true"
            >
              {/* Name now comes before the image */}
              <div className="hidden md:flex flex-col items-end mr-2">
                <span className="text-sm font-medium text-gray-700">{userName || 'User'}</span>
              </div>
              <img 
                className="w-8 h-8 rounded-full border border-gray-200"
                src={profileImage || defaultProfileImage}
                alt="User profile"
                onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                  (e.target as HTMLImageElement).src = defaultProfileImage;
                }}
              />
              <svg 
                className={`w-4 h-4 ml-1 text-gray-500 transition-transform duration-200 ${show ? 'rotate-180' : ''}`}
                xmlns="http://www.w3.org/2000/svg" 
                viewBox="0 0 24 24"
                fill="currentColor"
              >
                <path d="M7 10l5 5 5-5z" />
              </svg>
            </button>
            
            {show && (
              <div 
                ref={dropdownRef}
                className="absolute right-0 mt-2 bg-white shadow-lg rounded-md w-48 py-1 z-10 border border-gray-200"
              >
                <div className="px-4 py-2 border-b border-gray-200">
                  <div className="flex items-center justify-between space-x-2">
                    <div>
                      <p className="text-sm font-medium text-gray-700">{userName || 'User'}</p>
                    </div>
                    <img 
                      className="w-10 h-10 rounded-full"
                      src={profileImage || defaultProfileImage}
                      alt="User profile"
                      onError={(e: React.SyntheticEvent<HTMLImageElement>) => {
                        (e.target as HTMLImageElement).src = defaultProfileImage;
                      }}
                    />
                  </div>
                </div>
                <div className="px-2 py-1">
                  <PageLayout />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </header>
  );
}
